import Link from 'next/link';
import {
  Disclosure,
  Transition,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';

import type {
  MenuPanelProps,
  HeaderCompactСustomizationProps,
} from '../HeaderCompact';

export const DisclosureMenuPanel = ({
  blok,
  disclosureTransitionProps,
}: MenuPanelProps &
  Pick<HeaderCompactСustomizationProps, 'disclosureTransitionProps'>) => {
  const { links } = blok;

  const sortedLinks = Array.isArray(links)
    ? [...links].sort((a, b) => {
        const aLinksLength = Number(a?.links?.length);
        const bLinksLength = Number(b?.links?.length);

        if (aLinksLength < bLinksLength) {
          return -1;
        }

        if (bLinksLength > aLinksLength) {
          return 1;
        }

        return 0;
      })
    : [];

  return (
    <nav className='z-10 flex w-full pt-22 overflow-y-scroll'>
      {Array.isArray(sortedLinks) && sortedLinks.length > 0 && (
        <ul className='relative grid  w-full grid-cols-2'>
          {sortedLinks.map((item) => {
            const { _uid, title, links, mainLink } = item;

            const haveLink =
              mainLink && Boolean(mainLink?.url && mainLink?.title);

            const withDisclosure = Array.isArray(links) && links.length > 0;

            return (
              <li key={_uid} className={withDisclosure ? 'col-span-2' : ''}>
                {haveLink && (
                  <Link
                    href={mainLink.url}
                    className='button block px-6 py-3.5'
                  >
                    {mainLink.title}
                  </Link>
                )}
                {withDisclosure && (
                  <Disclosure>
                    <DisclosureButton className='button w-full px-6 py-3 text-left font-semibold mt-11'>
                      {title}
                    </DisclosureButton>
                    <Transition
                      {...disclosureTransitionProps}
                      enter='transition duration-100 ease-out'
                      enterFrom='transform scale-95 opacity-0'
                      enterTo='transform scale-100 opacity-100'
                      leave='transition duration-100 ease-out'
                      leaveFrom='transform scale-100 opacity-100'
                      leaveTo='transform scale-95 opacity-0'
                    >
                      <DisclosurePanel className='grid grid-cols-2 gap-2 pb-2'>
                        {links?.map((item) => {
                          const { _uid, link } = item;

                          return (
                            <Link
                              key={_uid}
                              href={link?.url}
                              className='header-panel-disclosure-item button text-lg px-6 py-3.5'
                            >
                              {link?.title}
                            </Link>
                          );
                        })}
                      </DisclosurePanel>
                    </Transition>
                  </Disclosure>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </nav>
  );
};
